import { render, staticRenderFns } from "./BuyingInfoRetailListingAnalysis.vue?vue&type=template&id=08dd77c2&scoped=true&"
import script from "./BuyingInfoRetailListingAnalysis.vue?vue&type=script&lang=js&"
export * from "./BuyingInfoRetailListingAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BuyingInfoRetailListingAnalysis.vue?vue&type=style&index=0&id=08dd77c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd77c2",
  null
  
)

export default component.exports